var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTileHistorial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9c124b2-4c98-41bd-bb8f-dd67d8afbb13",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.79223,78.8788H17.45281a.88146.88146,0,0,1-.88123-.88123V27.64209a.88146.88146,0,0,1,.88123-.88123h61.037a.88146.88146,0,0,1,.88124.88123V50.05335a.88124.88124,0,0,1-1.76247,0v-21.53H18.33405v48.593H68.79223a.88124.88124,0,1,1,0,1.76247Z",
    fill: "#403c3c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.48983,36.15324h-61.037a.88124.88124,0,0,1,0-1.76247h61.037a.88124.88124,0,1,1,0,1.76247Z",
    fill: "#403c3c"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.16185,
    y: 41.4439,
    width: 45.61873,
    height: 7.05564,
    fill: "#eb9180"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.658,56.36772H38.28462a.88124.88124,0,1,1,0-1.76247H57.658a.88124.88124,0,0,1,0,1.76247Z",
    fill: "#403c3c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.658,62.61325H38.28462a.88124.88124,0,1,1,0-1.76247H57.658a.88124.88124,0,0,1,0,1.76247Z",
    fill: "#403c3c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.23221,58.82267H72.74746a.88146.88146,0,0,1-.88123-.88123V55.79572a6.62361,6.62361,0,1,1,13.24721,0v2.14572A.88146.88146,0,0,1,84.23221,58.82267ZM73.6287,57.0602H83.351V55.79572a4.86114,4.86114,0,1,0-9.72227,0Z",
    fill: "#403c3c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.18687,78.8788H68.79223a.88146.88146,0,0,1-.88124-.88123V57.94144a.88146.88146,0,0,1,.88124-.88124H88.18687a.88146.88146,0,0,1,.88123.88124V77.99757A.88146.88146,0,0,1,88.18687,78.8788Zm-18.5134-1.76247H87.30563V58.82267H69.67347Z",
    fill: "#403c3c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45224,73.23913H11.81313a.88146.88146,0,0,1-.88123-.88124V22.00242a.88146.88146,0,0,1,.88123-.88124h53.4926a.88146.88146,0,0,1,.88123.88124v5.63967a.88124.88124,0,1,1-1.76247,0V22.88365H12.69437v48.593h4.75787a.88124.88124,0,0,1,0,1.76247Z",
    fill: "#403c3c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.48983,69.84557a3.52494,3.52494,0,1,1,3.525-3.52494A3.5288,3.5288,0,0,1,78.48983,69.84557Zm0-5.28741a1.76247,1.76247,0,1,0,1.76248,1.76247A1.7644,1.7644,0,0,0,78.48983,64.55816Z",
    fill: "#403c3c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.48983,72.783a.88146.88146,0,0,1-.88123-.88123V68.96433a.88124.88124,0,0,1,1.76247,0v2.93746A.88146.88146,0,0,1,78.48983,72.783Z",
    fill: "#403c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileHistorial);
export default __webpack_public_path__ + "static/media/tile_historial.c0c7ea6f7ed119a16fa40b9ccfeeef5b.svg";
export { ForwardRef as ReactComponent };